import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MyListing from "../pages/MyListingPage/MyListingPage";

// Regular expression to match UUIDs (version 4)
const CUSTOM_REGEX = /^[pctu][A-Za-z0-9]{6}$/;

const ListingRoute: React.FC = () => {
  const { userParam } = useParams<{ userParam: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (userParam && !CUSTOM_REGEX.test(userParam)) {
      navigate("/", { replace: true });
    }
  }, [userParam, navigate]);

  if (!userParam || !CUSTOM_REGEX.test(userParam)) {
    navigate("/", { replace: true });
    return null;
  }

  return <MyListing public_id={userParam} />;
};

export default ListingRoute;
